export const AUTH0_ERROR_MAPPING = {
  ERR_AUTH_UNKNOWN_DOMAIN: `We don't recognize this domain, if you're a new customer please reach out here, if you think this is a mistake and you should have access reach out to support here.`,
  ERR_AUTH_SSO_REQUIRED:
    'Your organization requires single sign-on. Please return to the login page and sign in with SSO.',
};
